<template>
  <div class="container">
    <h1>Dodane aktualności</h1>
    <table v-if="!fetching" class="table table-striped">
      <thead>
        <tr class="tr-table">
          <th scope="col">Kolejność</th>
          <th scope="col">Nazwa</th>
          <th scope="col">Data(od)</th>
          <th scope="col">Data(do)</th>
          <th scope="col">Rodzaj</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          :class="isPassedDate(item.date_to) ? 'passed-row' : ''"
          v-for="(item, index) in news"
          :key="item.id"
        >
          <td>{{ index + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>
            {{ formattedDateWithTime(item.date_from) }}
            <!-- {{ item.date_from ? item.date_from.substring(0, 10) : "" }} <br />
            {{ item.date_from ? item.date_from.substring(11, 19) : "" }} -->
          </td>
          <td>
            {{ formattedDateWithTime(item.date_to) }}
            <!-- {{ item.date_to ? item.date_to.substring(0, 10) : "" }} <br />
            {{ item.date_to ? item.date_to.substring(11, 19) : "" }} -->
          </td>
          <td>
            {{ translateType(item.type) }} <br />
            <span v-if="item.type === 'DISCOUNT'"
              >{{ item.promotional_code.value }}zł</span
            >
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td>
            <div style="display: flex; gap: 10px" class="">
              <button
                @click="startEditingProcess(item)"
                class="btn btn-sm btn-outline-dark downloadButton"
              >
                Edytuj
              </button>
              <button
                @click="deleteNews(item)"
                class="btn btn-sm btn-outline-dark downloadButton make-pink"
              >
                Usuń
              </button>
            </div>
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <div
      style="display: grid; place-items: center; min-height: 300px"
      class=""
      v-else
    >
      <loader></loader>
    </div>

    <div class="adding-section">
      <h1>Dodawanie aktualności</h1>
      <div class="buttons-select">
        <select
          style="min-width: 390px"
          v-model="chosenType"
          class="form-control"
        >
          <option disabled :value="null">Wybierz typ</option>
          <option :value="type.value" v-for="type in types" :key="type.value">
            {{ type.name }}
          </option>
        </select>
        <div
          @click="closeAdding(false), (adding = true)"
          class="add-button"
          style="cursor: pointer"
        >
          + Dodaj
        </div>
      </div>
    </div>
    <div v-if="adding" class="add-news-section">
      <div class="parent">
        <div style="width: 109px" class="div1">
          <label for="">Kolejność</label>
          <select
            style="height: 32px; width: 106px"
            v-model="priority"
            class="form-control"
          >
            <option
              :value="index + 1"
              v-for="(news, index) in editing ? news.length : news.length + 1"
              :key="index"
            >
              {{ index + 1 }}
            </option>
          </select>
        </div>
        <div class="div2">
          <div style="margin-top: -6px" class="input-container">
            <label>Nazwa</label>
            <input
              v-model="name"
              style="height: 32px; width: 368px"
              class="form-control"
              type="text"
              required
              minlength="1"
            />
          </div>
        </div>
        <div class="div3">
          <div style="margin-top: -6px" class="input-container">
            <label>{{
              chosenType === "DISCOUNT"
                ? "Kod rabatowy"
                : chosenType === "LINK"
                ? "Link"
                : "Wybierz usługę"
            }}</label>
            <input
              v-if="chosenType === 'LINK'"
              style="height: 32px; width: 368px"
              v-model="discount"
              class="form-control"
              type="text"
              required
              minlength="1"
            />
            <select
              v-if="chosenType === 'DISCOUNT'"
              style="min-width: 368px; height: 32px"
              v-model="discount"
              class="form-control"
            >
              <option disabled :value="null">Wybierz kod</option>
              <option
                :value="code.id"
                v-for="code in allPromotionalCodes"
                :key="code.id"
              >
                {{ code.code }}
              </option>
            </select>
            <select
              v-if="chosenType === 'SERVICE'"
              style="min-width: 368px; height: 32px"
              v-model="discount"
              class="form-control"
            >
              <option disabled :value="null">Wybierz kod</option>
              <option
                :value="service.id"
                v-for="service in serviceCategoriesToSelect"
                :key="service.id"
              >
                {{ service.display_name }}
              </option>
            </select>
          </div>
        </div>
        <div style="width: 106px" class="div4">
          <label>Data (od)</label>
          <input
            :max="toDate ? toDate : ''"
            class="input-as-button"
            style="width: 106px; height: 32px"
            type="date"
            v-model="fromDate"
          />
        </div>
        <div style="width: 106px" class="div5">
          <input
            class="input-as-button"
            style="
              width: 106px;
              margin-top: 22px;
              height: 32px;
              margin-left: 5px;
            "
            v-model="fromHour"
            type="time"
            required
          />
        </div>
        <div style="width: 106px" class="div6">
          <label>Data (do)</label>
          <input
            :min="fromDate ? fromDate : ''"
            class="input-as-button"
            style="width: 106px; height: 32px"
            type="date"
            v-model="toDate"
          />
        </div>
        <div style="width: 106px" class="div7">
          <input
            class="input-as-button"
            style="
              width: 106px;
              margin-top: 22px;
              height: 32px;
              margin-left: 5px;
            "
            v-model="toHour"
            type="time"
            required
          />
        </div>
        <div class="div8">
          <div
            v-if="chosenType === 'DISCOUNT'"
            class=""
            style="display: flex; gap: 0 30px"
          >
            <div
              style="display: flex; flex-direction: column; margin-top: -10px"
              class="control control--input"
            >
              <label>Grafika przed kliknięciem</label>
              <label for="avatar" class="control__label galery-custom-btn">
                <div class="input-as-button">
                  {{
                    fileBefore.name
                      ? fileBefore.name.substring(0, 20) + "..."
                      : "Wybierz plik"
                  }}
                </div>
              </label>
              <input
                type="file"
                id="avatar"
                @change="getImageBefore"
                accept=".jpg, .jpeg, .png"
                style="display: none; width: 163px"
              />
            </div>
            <div
              style="display: flex; flex-direction: column; margin-top: -10px"
              class="control control--input"
            >
              <label>Grafika po kliknięciu</label>
              <label for="avatar2" class="control__label galery-custom-btn">
                <div class="input-as-button">
                  {{
                    fileAfter.name
                      ? fileAfter.name.substring(0, 20) + "..."
                      : "Wybierz plik"
                  }}
                </div>
              </label>
              <input
                type="file"
                id="avatar2"
                @change="getImageAfter"
                accept=".jpg, .jpeg, .png"
                style="display: none; width: 163px"
              />
            </div>
          </div>
          <div class="" v-else>
            <div
              style="display: flex; flex-direction: column; margin-top: -10px"
              class="control control--input"
            >
              <label>Grafika(452x216px)</label>
              <label for="avatar" class="control__label galery-custom-btn">
                <div class="input-as-button" style="width: 364px">
                  {{
                    fileBefore.name
                      ? fileBefore.name.substring(0, 30) + "..."
                      : "Wybierz plik"
                  }}
                </div>
              </label>
              <input
                @change="getImageBefore"
                type="file"
                id="avatar"
                accept=".jpg, .jpeg, .png"
                style="display: none"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="form-buttons">
        <div @click="closeAdding(true)" class="return-button">Anuluj</div>
        <div @click="submit" class="saving-button">Zapisz</div>
      </div>
    </div>
  </div>
</template>
<script>
import Loader from "@/components/Loader";
import shared from "./../../shared";

export default {
  components: { Loader },
  data() {
    return {
      serviceCategoriesToSelect: [],
      fetching: true,
      chosenType: "SERVICE",
      priority: "",
      name: "",
      discount: "",
      fromDate: "",
      fromHour: "00:00:00",
      toDate: "",
      toHour: "00:00:00",
      fileBefore: "",
      fileAfter: "",
      adding: false,
      editing: false,
      currentlyEditingId: "",
      wholeEditingObject: "",
      formattedDateWithTime: null,
      types: [
        {
          name: "Kod rabatowy",
          value: "DISCOUNT",
        },
        {
          name: "Link",
          value: "LINK",
        },
        {
          name: "Promowanie usługi",
          value: "SERVICE",
        },
      ],
    };
  },
  mounted() {
    this.formattedDateWithTime = shared.formattedDateAsNumbers;
  },
  async created() {
    this.$store.dispatch("fetchServiceCategoriesWithServices").then(() => {
      this.serviceCategories.forEach((serviceCategory) => {
        if (!serviceCategory.is_hidden) {
          this.serviceCategoriesToSelect.push({
            id: serviceCategory.id,
            name: serviceCategory.name,
            display_name: serviceCategory.display_name,
          });
        }
      });
      this.serviceCategoriesToSelect.sort((item1, item2) => {
        if (item1.display_name < item2.display_name) return -1;
        if (item1.display_name > item2.display_name) return 1;
        return 0;
      });
    });
    await this.$store.dispatch("fetchNews");
    await this.$store.dispatch("getAllCodes", true);
    setTimeout(() => {
      this.fetching = false;
    }, 500);
  },
  methods: {
    getImageBefore(e) {
      e.preventDefault();
      this.fileBefore = e.target.files[0];
    },
    getImageAfter(e) {
      e.preventDefault();
      this.fileAfter = e.target.files[0];
    },
    isPic(filename) {
      let extension = filename ? filename.split(".").pop() : "";
      if (
        extension.toLowerCase() === "png" ||
        extension.toLowerCase() === "jpg" ||
        extension.toLowerCase() === "jpeg"
      )
        return true;
      else return false;
    },

    async submit() {
      if (
        this.priority !== "" &&
        this.name !== "" &&
        this.discount !== "" &&
        this.fromDate !== "" &&
        this.fromDate !== null &&
        this.fromHour !== "" &&
        this.toDate !== "" &&
        this.toDate !== null &&
        this.toHour !== ""
      ) {
        let body = new FormData();
        body.append("name", this.name);
        if (this.news[this.priority - 1]) {
          body.append("priority", this.news[this.priority - 1].priority);
        } else if (this.news[this.priority - 2]) {
          body.append("priority", this.news[this.priority - 2].priority + 1);
        } else {
          body.append("priority", "1");
        }
        body.append("type", this.chosenType);
        if (this.fromHour.length === 5) this.fromHour += ":00";
        if (this.toHour.length === 5) this.toHour += ":00";
        body.append("date_from", `${this.fromDate}T${this.fromHour}.000`);
        body.append("date_to", `${this.toDate}T${this.toHour}.000`);

        if (
          this.chosenType === "DISCOUNT" &&
          this.fileBefore !== "" &&
          this.isPic(this.fileBefore.name) &&
          this.isPic(this.fileAfter.name) &&
          this.fileAfter !== ""
        ) {
          //TYP DISCOUNT
          body.append("promotional_code_id", this.discount);
          body.append("image_before", this.fileBefore);
          body.append("image_after", this.fileAfter);
          if (this.editing) {
            let wrap = {
              id: this.currentlyEditingId,
              obj: body,
            };
            await this.$store.dispatch("editNews", wrap);
          } else {
            await this.$store.dispatch("addNews", body);
          }

          this.$notify({
            group: "success",
            text: "Poprawnie dodano aktualność",
          });
          await this.$store.dispatch("fetchNews");
          this.closeAdding(true);
          //    TYP DISCOUNT
        } else if (
          this.chosenType !== "DISCOUNT" &&
          this.fileBefore !== "" &&
          this.isPic(this.fileBefore.name)
        ) {
          //    TYP INNY NIZ DISCOUNT
          body.append("image_before", this.fileBefore);
          if (this.chosenType === "LINK") body.append("link", this.discount);
          if (this.chosenType === "SERVICE")
            body.append("service_category_id", this.discount);
          if (this.editing) {
            let wrap = {
              id: this.currentlyEditingId,
              obj: body,
            };
            await this.$store.dispatch("editNews", wrap);
          } else {
            await this.$store.dispatch("addNews", body);
          }
          this.$notify({
            group: "success",
            text: "Poprawnie dodano aktualność",
          });
          await this.$store.dispatch("fetchNews");
          this.closeAdding(true);
          //    TYP INNY NIZ DISCOUNT
        } else {
          this.$notify({
            group: "error",
            text: "Dodaj grafikę o rozszerzeniu .jpg, .png lub .jpeg, aby dodać aktualność",
          });
        }
      } else {
        this.$notify({
          group: "error",
          text: "Uzupełnij wszystkie pola ",
        });
      }
    },
    async closeAdding(reload) {
      if (reload) this.fetching = true;
      this.priority = "";
      this.name = "";
      this.discount = "";
      this.fromDate = "";
      this.fromHour = "00:00:00";
      this.toDate = "";
      this.toHour = "00:00:00";
      this.adding = false;
      this.editing = false;
      setTimeout(async () => {
        await this.$store.dispatch("fetchNews");
      }, 1800);
      setTimeout(async () => {
        this.fetching = false;
      }, 2000);
    },
    translateType(type) {
      return type === "DISCOUNT"
        ? "Kod rabatowy"
        : type === "LINK"
        ? "Link"
        : "Promowanie usługi";
    },
    isPassedDate(date) {
      if (new Date(date) > new Date()) return false;
      else return true;
    },
    async deleteNews(news) {
      const confirm = prompt(
        `Czy na pewno chcesz usunąć aktualność "${news.name}"? Potwierdź wpisując 'USUŃ'`
      );
      if (confirm.toUpperCase() === "USUŃ") {
        try {
          const response = this.$store.dispatch("deleteNews", news.id);
          if (response) {
            this.$notify({
              group: "success",
              text: "Usunięto aktualność.",
            });
            await this.$store.dispatch("fetchNews");
            this.closeAdding(true);
          }
        } catch (err) {
          this.$notify({
            group: "error",
            text: "Wystąpił błąd podczas próby usunięcia. Spróbuj ponownie",
          });
        }
      }
    },
    async startEditingProcess(oneNews) {
      this.fromDate = oneNews.date_from.substring(0, 10);
      this.fromHour = oneNews.date_from.substring(11, 19);
      this.toDate = oneNews.date_to.substring(0, 10);
      this.toHour = oneNews.date_to.substring(11, 19);
      let tmp = {
        name: oneNews.image_before_id,
      };
      this.fileBefore = tmp;
      this.priority = this.news.indexOf(oneNews) + 1;
      this.name = oneNews.name;
      this.chosenType = oneNews.type;
      if (oneNews.type === "DISCOUNT") {
        this.discount = oneNews.promotional_code.id;
        let tmp2 = {
          name: oneNews.image_after_id,
        };
        this.fileAfter = tmp2;
      }
      if (oneNews.type === "LINK") {
        this.discount = oneNews.redirect_link;
      }
      if (oneNews.type === "SERVICE") {
        this.discount = oneNews.service_category.id;
      }
      this.wholeEditingObject = oneNews;
      this.adding = true;
      this.editing = true;
      this.currentlyEditingId = oneNews.id;
    },
  },
  computed: {
    news() {
      return this.$store.getters.getNews;
    },
    allPromotionalCodes() {
      return this.$store.getters.getAllPromotionalCodes;
    },
    serviceCategories() {
      return this.$store.getters.getServiceCategoryWithServices;
    },
  },
};
</script>
<style scoped>
.container {
  width: 1018px;
  height: 100%;
  padding: 40px;
  background: #fafafa;
}
.container h1 {
  font-weight: 400;
  font-size: 20px;
}
.table .tr-table th {
  font-weight: 500 !important;
  font-size: 16px !important;
  text-align: center !important;
}
td {
  font-size: 12px;
  font-weight: 400;
  text-align: center !important;
}
.downloadButton {
  min-width: 48px;
}
.make-pink {
  background: #e2037e !important;
}
.add-button {
  width: 106px;
  height: 36px;
  color: #fff;
  background: #090741;
  border-radius: 3.56846px;
  display: grid;
  place-items: center;
}
.buttons-select {
  margin-top: -20px;
  display: flex;
  gap: 10px;
  align-items: center;
}
.adding-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.parent {
  display: grid;
  grid-template-columns: repeat(14, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}

.div1 {
  grid-area: 1 / 1 / 2 / 3;
}
.div2 {
  grid-area: 1 / 3 / 2 / 9;
}
.div3 {
  grid-area: 1 / 9 / 2 / 15;
}
.div4 {
  grid-area: 2 / 1 / 3 / 3;
}
.div5 {
  grid-area: 2 / 3 / 3 / 5;
}
.div6 {
  grid-area: 2 / 5 / 3 / 7;
}
.div7 {
  grid-area: 2 / 7 / 3 / 9;
}
.div8 {
  grid-area: 2 / 9 / 3 / 15;
}

.input-as-button {
  width: 163px;
  height: 32px;
  background: rgba(9, 7, 65, 0.02);
  border: 1px solid rgba(9, 7, 65, 0.25);
  border-radius: 3px;
  cursor: pointer;
  display: grid;
  place-items: center;
}
.form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0 30px;
}
.return-button,
.saving-button {
  padding: 4px 0px;
  width: 163px;
  height: 32px;
  background: rgba(9, 7, 65, 0.05);
  border-radius: 3.56846px;
  display: grid;
  place-items: center;
  font-weight: 400;
  font-size: 16px;
  cursor: pointer;
  margin-right: 10px;
}
.saving-button {
  background: #090741;
  color: #fff;
}
.passed-row {
  background: rgba(245, 10, 10, 0.1) !important;
}
</style>
